import { render, staticRenderFns } from "./select-animation.vue?vue&type=template&id=34924cee&scoped=true"
import script from "./select-animation.vue?vue&type=script&lang=ts"
export * from "./select-animation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34924cee",
  null
  
)

export default component.exports